<template>
<div class="topbar">
    <div class="topbar-row">
        <div class="topbar-search" v-if="!isLoggedIn">
            <SearchBar />
        </div>
        <div class="topbar-links">
            <a href="https://app.yalla.team" target="_blank" rel="noopener">Yalla</a>
            <span class="divider">|</span>
            <a href="https://lemonadestandinc.groovehq.com/" target="_blank" rel="noopener">Groove</a>
            <span class="divider">|</span>
            <a href="https://gusto.com/login" target="_blank" rel="noopener">Gusto</a>
            <span class="divider">|</span>
            <a href="https://app.qwilr.com/#/login" target="_blank" rel="noopener">Qwilr</a>
            <span class="divider">|</span>
            <a href="https://buildthenbless.app/dashboard" target="_blank" rel="noopener">BuildThenBless</a>
        </div>
    </div>
</div>
</template>

<script>
// Topbar: Displays only the search bar, left-aligned
import SearchBar from './SearchBar.vue';

export default{
    name: 'Topbar',
    components: { SearchBar },
    computed: {
        isLoggedIn() {
            // Replace this with your actual login check logic
            // For example, check a Vuex store, cookie, or localStorage
            return !!localStorage.getItem('userToken');
        }
    }
}
</script>

<style>
.topbar {
    height: 60px;
    padding-top: 2rem;
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    position: relative;
}
.topbar-row {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
}
.topbar-search {
    width: 66.66vw; /* 2/3 of the viewport width */
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    flex: 0 1 auto;
}
.topbar-links {
    display: flex;
    align-items: center;
    gap: 0.8em;
    margin-left: 2em;
    color: #888;
    font-size: 1em;
    font-weight: 500;
}
.topbar-links a {
    color: #888;
    text-decoration: none;
    font-weight: 400;
    font-size: 1em;
    transition: color 0.2s;
}
.topbar-links a:hover {
    color: #04496b;
    text-decoration: underline;
}
.divider {
    color: #ccc;
    margin: 0 0.5em;
    user-select: none;
}
@media (max-width: 1100px) {
  .topbar {
    height: auto;
    padding: 10px 0;
  }
  .topbar-row {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 0.5em;
  }
  .topbar-search {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
  }
  .topbar-links {
    width: 100%;
    margin-left: 0;
    justify-content: center; /* Center align links */
    flex-wrap: wrap;
    gap: 0.8em 1.5em;
    padding-top: 0.5em;
    font-size: 1em;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .topbar-links a {
    font-size: 1em;
    display: inline-block;
  }
}
</style>